import React from 'react';
import { PageContent } from '~/__modules__/page';
import { NotFoundMessage } from '~/__modules__/error';

export default function NotFoundScene() {
  return (
    <PageContent empty={true}>
      <NotFoundMessage />
    </PageContent>
  );
}
